$(document).ready(function(){

	// -- Focus --
	$('#searchInput').on('focusin', function(){
		$(this).parents('.header__search').addClass('open');
		$(this).parent('form').find('button').attr('tabindex', '0');
	});

	$('#searchInput').on('focusout', function(){
		$(this).parents('.header__search').removeClass('open');
		$(this).parent('form').find('button').attr('tabindex', '-1');
	});
	
});